import { render, staticRenderFns } from "./KiosksNew.vue?vue&type=template&id=69c0aa2d"
import script from "./KiosksNew.vue?vue&type=script&lang=js"
export * from "./KiosksNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports